/**
 * App-wide transient notifications — enterprise compact toast (DesignTest/DESIGN.md Suite 03).
 */
import React from "react";
import EnterpriseMessageToast from "./enterpriseMessages/EnterpriseMessageToast";

function severityToVariant(severity) {
  if (severity === "success") return "success";
  if (severity === "error") return "error";
  if (severity === "warning") return "warning";
  return "info";
}

function normalizeProps(props) {
  const {
    open: openProp,
    onClose: onCloseProp,
    message: messageProp,
    severity: severityProp,
    autoHideDuration: autoHideDurationProp,
    actionLabel: actionLabelProp,
    onAction: onActionProp,
    snackbar,
    setSnackbar,
    detail,
    title,
  } = props;

  if (snackbar != null && typeof snackbar === "object") {
    const close = () => {
      if (setSnackbar) {
        setSnackbar((prev) =>
          typeof prev === "object" ? { ...prev, open: false } : { open: false, message: "", severity: "success" }
        );
      }
      onCloseProp?.();
    };
    return {
      open: Boolean(snackbar.open),
      onClose: close,
      message: snackbar.message ?? "",
      severity: snackbar.severity ?? "success",
      autoHideDuration: autoHideDurationProp ?? snackbar.autoHideDuration ?? 6000,
      actionLabel: actionLabelProp ?? snackbar.actionLabel,
      onAction: onActionProp ?? snackbar.onAction,
      detail: detail ?? snackbar.detail,
      title: title ?? snackbar.title,
    };
  }

  return {
    open: Boolean(openProp),
    onClose: onCloseProp,
    message: messageProp ?? "",
    severity: severityProp ?? "success",
    autoHideDuration: autoHideDurationProp ?? 6000,
    actionLabel: actionLabelProp,
    onAction: onActionProp,
    detail,
    title,
  };
}

export const SnackbarNotification = (props) => {
  const normalized = normalizeProps(props);

  const {
    open,
    onClose,
    message,
    severity,
    autoHideDuration,
    actionLabel,
    onAction,
    detail,
    title,
  } = normalized;

  if (!message && !open) return null;

  const variant = severityToVariant(severity);

  const handleClose = (...args) => {
    onClose?.(...args);
  };

  return (
    <EnterpriseMessageToast
      open={open}
      variant={variant}
      title={title}
      message={message}
      detail={detail ?? message}
      actionLabel={actionLabel}
      onAction={onAction}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}
    />
  );
};
